import React from 'react';
import { TouchableOpacity } from 'react-native';
import { rem } from 'design-system/values';
import AccountCard from 'design-system/AccountCard';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableHighlight from 'utils/packages/TouchableHighlight';
import { isWeb } from '../constants';
import RadioButton from './RadioButton';
export const SelectableAccountCard = ({ isSelected, data, type = 'multiple', transparent, disabled, onPress, onOpenLogins, hideActionRequiredText, ...props }) => {
    const colors = useColors();
    const styles = useStyles(stylesSet);
    const content = (<TouchableOpacity activeOpacity={0.5} style={[
            styles.container,
            transparent && styles.transparent,
            disabled && styles.disabled,
        ]} onPress={!disabled ? () => onPress?.(data) : undefined}>
      <RadioButton isChecked={!disabled && isSelected} type={type}/>
      <AccountCard {...props} hideActionRequiredText={hideActionRequiredText} onOpenLogins={onOpenLogins} alt onCard data={data} style={styles.accountCard} transparent={isWeb || transparent}/>
    </TouchableOpacity>);
    if (disabled) {
        return content;
    }
    return (<TouchableHighlight onCard hoverOnLight activeOpacity={1} underlayColor={colors.background.underlay}>
      {content}
    </TouchableHighlight>);
};
const stylesSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        ...(isWeb
            ? {
                paddingLeft: rem(8),
            }
            : {
                paddingHorizontal: rem(16),
            }),
        backgroundColor: isWeb ? 'transparent' : colors.cards.onDark,
    },
    transparent: {
        backgroundColor: 'transparent',
    },
    disabled: {
        opacity: 0.5,
    },
    accountCard: {
        flex: 1,
        paddingRight: 0,
        paddingLeft: rem(isWeb ? 8 : 16),
        paddingHorizontal: 0,
        justifyContent: 'space-evenly',
    },
}));
